import "./SuccessCasesCard.scss";
import LinkWithArrow from "../../Atoms/LinkWithArrow/LinkWithArrow";
import ReactMarkdown from "react-markdown";

const SuccessCasesCard = ({
	leftImage,
	image,
	yellowTitle,
	boldTitle,
	content,
	linkRoute,
	linkText
}) => {
	return (
		<div
			className={`successCasesCard-container ${
				leftImage ? "left-case" : "right-case"
			}`}
		>
			<div
				className={`successCasesCard-image-container ${
					leftImage ? "left-case" : "right-case"
				}`}
			>
				<img
					src={image}
					alt="Camión"
					className={`all-width-height successCasesCard-image ${
						leftImage ? "left-case" : "right-case"
					}`}
				/>
			</div>
			<div
				className={`successCasesCard-content-container ${
					leftImage ? "left-case" : "right-case"
				}`}
			>
				<h5 className="c-yellow t5">{yellowTitle.toUpperCase()}</h5>
				<h4 className="t4 no-space">{boldTitle}</h4>
				<div className="successCasesCard--markdown-container">
					<ReactMarkdown>{content}</ReactMarkdown>
				</div>
				<LinkWithArrow linkRoute={linkRoute} linkText={linkText} />
			</div>
		</div>
	);
};

export default SuccessCasesCard;
